import React, { useState } from "react";
import PropTypes from "prop-types";
import {Container, Row, Col} from 'react-bootstrap';
import { CircularProgressbar  } from 'react-circular-progressbar';
// import router
import { Link, withRouter, useHistory } from "react-router-dom";
// import { Link, withRouter, useHistory } from "react-router-dom"
import 'react-circular-progressbar/dist/styles.css';
import Logo from '../../assets/images/logos/logo.png';
// import common components
import Sidebar from "./Sidebar";
import Banner from "../common/Banner";

// import constants
import { USER_DATA } from "../../helpers/constants";

const Blocker = ({ children, history }) => {
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem(USER_DATA))
  );
  const [profileCompletePercentage, setProfileCompletePercentage] = useState(100);
  let profilePercentage = profileCompletePercentage == 20 ? '#F5CD28' : profileCompletePercentage == 40 ? '#E5F528' : profileCompletePercentage == 60 ? '#12CFEF' : profileCompletePercentage == 80 ? '#9DC828' : profileCompletePercentage == 100 ? '#6EBE4A' : '';
  return (
    <React.Fragment>
      <div className="account-main">
        {/* <Banner bannerId="account-banner" /> */}

        <div className="leave-links d-flex align-items-center justify-content-between">
          <div onClick={() => history.goBack()}>
            <i className="bx bx-arrow-back me-1"></i>
            Page précédente
          </div>
          <Link to="/">
            <i className="bx bxs-home me-1"></i>
            Accueil
          </Link>
        </div>

        <Container className="py-4 px-2" style={{maxWidth: '992px'}} >
                    <Row className="row">
                        <Col xs="2">
                            {(userData && userData.id) ? (
                                <>
                                    <div className="avatar-xl mx-auto mb-3 position-relative">
                                        <div style={{ width: '100%', height: '100%', margin:'auto' }}>
                                            <CircularProgressbar value={profileCompletePercentage} text={`${profileCompletePercentage}%`} strokeWidth="3" className="student-profile"                                            
                                            styles={{
                                                path: {
                                                    transform: 'rotate(0.30turn)',
                                                    stroke: `${profilePercentage}`,
                                                    transformOrigin: 'center center',
                                                },
                                              }}
                                              />
                                            <div className="profile-camera"><i className='bx bx-camera'></i></div>
                                        </div>
                                        {!userData.avatar ? (
                                            <span className="avatar-title rounded-circle sidebar-avatar">
                                                {/* {(userData.name.charAt(0).toUpperCase() || "") + (userData.name.charAt(1).toUpperCase() || "")} */}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="42" viewBox="0 0 44 42" fill="none">
                                                  <path d="M43.2708 40.385C43.1256 40.6307 42.9169 40.8347 42.6655 40.9765C42.4141 41.1184 42.1289 41.193 41.8386 41.1929H2.16036C1.87029 41.1926 1.58541 41.1178 1.33432 40.9758C1.08323 40.8339 0.874764 40.6299 0.72986 40.3843C0.584957 40.1387 0.508715 39.8601 0.508789 39.5766C0.508864 39.2931 0.585252 39.0146 0.730285 38.7691C3.87768 33.4507 8.72794 29.6371 14.3883 27.8293C11.5884 26.2001 9.41311 23.7177 8.19639 20.7632C6.97967 17.8088 6.78884 14.5456 7.6532 11.4749C8.51755 8.40412 10.3893 5.69559 12.981 3.76524C15.5727 1.83488 18.7411 0.789429 21.9995 0.789429C25.2579 0.789429 28.4263 1.83488 31.018 3.76524C33.6097 5.69559 35.4814 8.40412 36.3458 11.4749C37.2102 14.5456 37.0193 17.8088 35.8026 20.7632C34.5859 23.7177 32.4106 26.2001 29.6107 27.8293C35.2711 29.6371 40.1213 33.4507 43.2687 38.7691C43.4141 39.0145 43.4909 39.2931 43.4912 39.5767C43.4916 39.8604 43.4156 40.1391 43.2708 40.385Z" fill="#B8E5ED"/>
                                                </svg>
                                            </span>
                                            // <></>
                                            
                                        ) : (
                                            <img className="rounded-circle avatar-md user-profile-image" src={Logo} alt="user avatar" />
                                            )}
                                    </div>
                            </>
                        ) : null}
                            <h5 className={`profile-complete-percentage ${profileCompletePercentage == 100 && 'profile-completed'}`}>{`${profileCompletePercentage <= 80 ? 'Profil en cours' : 'Félicitations! Votre profil est complet!'}`}</h5>
                            {
                                profileCompletePercentage !== 100 &&
                                <h3 className='profile-percentage' style={{color:profilePercentage}}>{`${profileCompletePercentage}%`}</h3>
                            }
                            {/* <h5 className="text-success text-center" style={{fontSize:'12px'}}>Félicitations!<br/> Votre profil est complet!</h5> */}
                        </Col>
                        <Col>
                            <h5 style={{
                                color: '#005073',
                                fontSize: '26px',
                                fontWeight: 500,
                                letterSpacing: '0.65px',
                                paddingTop: '20px',
                                marginBottom: '10px',
                            }}>{userData.name}</h5>
                            <span style={{
                                color: '#005073',
                                fontFamily: 'Montserrat',
                                fontSize: '14px',
                                borderRadius: '25px',
                                background: 'rgba(18, 207, 239, 0.12)',
                                display: 'inline-block',
                                padding:'5px 12px',
                                fontWeight: 500,
                                letterSpacing: '0.35px'
                            }}>ID: {userData.publicId}</span>
                        </Col>
                    </Row>
                    <Row className="row justify-content-between mt-4 mb-5">
                        <Col className="custom-sidebar">
                            <Sidebar user={userData} />
                        </Col>
                        <Col className="custom-sidebar-content">
                            {children}
                        </Col>
                        {/* <Col className="col-lg-2">
                            <p className="mb-0 p-2">
                                Ads and Informations
                            </p>
                        </Col> */}
                    </Row>
                </Container>

        {/* <div className="container-fluid py-4 px-2">
          <div className="row">
            <div className="col-lg-3">
              <Sidebar user={userData} />
            </div>
            <div className="col-lg-7">{children}</div>
            <div className="col-lg-2">
              <p className="mb-0 p-2">Ads and Informations</p>
            </div>
          </div>
        </div> */}
      </div>
    </React.Fragment>
  );
};

Blocker.propTypes = {
  children: PropTypes.node,
};
export default withRouter(Blocker);
